import $ from "jquery"
import store from '../../store/index'
import homeApi from '@/axios/home'
export default {
  openId:'openId',
  unionId:'unionId',
  isWeiXin() {
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true
    } else {
      return false
    }
  },
  isPlatform() {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1 ;//android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ;//ios终端
    if (isAndroid) {
      return "ANDROID"
    } else if (isiOS) {
      return "IOS"
    }
  },
  isIPX() {
    var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height == 812 && screen.width == 375){
          //是iphoneX
          return true
        }else{
            return false
        }
      }
  },
  GetQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    let r = window.location.search.substr(1).match(reg)
    if (r != null) return r[2]
    return null
  },
  formatDate(date = Date.now(), str = "YY-MM-DD") {
    const newDate = new Date(date);
    str = str.replace("YY", newDate.getFullYear());
    str = str.replace("MM", this.add0(newDate.getMonth() + 1));
    str = str.replace("DD", this.add0(newDate.getDate()));
    str = str.replace("hh", this.add0(newDate.getHours()));
    str = str.replace("mm", this.add0(newDate.getMinutes()));
    str = str.replace("ss", this.add0(newDate.getSeconds()));
    return str
  },
  add0(str){
    str = str + '';
    if(str.length >= 2){
      return str
    }else{
      return '0' + str
    }
  },
  phoneReg(tel){
    let reg = /^\d{11}$/;
    
  },
  //滚动添加动画css
  windowScrollAnimation: {
    init: function ( _el, type ) {
        let _this = this
        type = type || "onMiddle"
        $( window ).on( "scroll", function () {
            _this[type]( _el )
        } )
    },
    //元素滑动到屏幕中间 展示动画 超过或小于屏幕中间都会去掉动画
    onMiddle: function ( _el ) {
        $( _el ).each( function () {
            const _this = $( this )
            /*滚动高度*/
            let isScrollTop = $( window ).scrollTop() + ( $( window ).height() * 0.4 )
            let offsetTop = _this.offset().top
            let _class = _this.data( "animation" )
            let animationTimes = _this.data( "times" )
            // console.log(isScrollTop,offsetTop)
            if ( isScrollTop >= offsetTop - 100 && isScrollTop < offsetTop + 100 ) {
                if ( !_this.hasClass( _class ) ) {
                    _this.addClass( _class )
                }
            } else {
                if ( _this.hasClass( _class ) && animationTimes !== "once" ) {
                    _this.removeClass( _class )
                }
                
            }
        } )
    },
    //元素从下放出现 展示动画 超过屏幕中间去掉动画
    onBottom: function ( _el ) {
        $( _el ).each( function () {
            const _this = $( this )
            let isScrollTop = $( window ).scrollTop() + ( $( window ).height() * 0.9 )
            let offsetTop = _this.offset().top
            let _class = _this.data( "animation" )
            if ( isScrollTop > offsetTop ) {
                if ( !_this.hasClass( _class ) ) {
                    _this.addClass( _class )
                }
            } else {
                _this.removeClass( _class )
            }
        } )
       }
    },
    parallax () {
        // Create the defaults once
        var pluginName = "scrolly",
            defaults = {
                bgParallax: false
            },
            didScroll = false
        
        function Plugin ( element, options ) {
            this.element = element
            this.$element = $( this.element )
            
            this.options = $.extend( {}, defaults, options )
            
            this._defaults = defaults
            this._name = pluginName
            
            this.init()
        }
        
        Plugin.prototype.init = function () {
            var self = this
            this.startPosition = this.$element.position().top
            this.offsetTop = this.$element.offset().top
            this.height = this.$element.outerHeight( true )
            this.velocity = this.$element.attr( "data-velocity" )
            this.bgStart = parseInt( this.$element.attr( "data-fit" ), 10 )
            this.opacity = 1
            
            $( document ).scroll( function () {
                self.didScroll = true
            } )
            
            setInterval( function () {
                if ( self.didScroll ) {
                    self.didScroll = false
                    self.scrolly()
                }
            }, 10 )
        }
        
        Plugin.prototype.scrolly = function () {
            var dT = $( window ).scrollTop(),
                wH = $( window ).height(),
                position = this.startPosition,
                opacity = this.opacity
            
            if ( this.offsetTop >= ( dT + wH ) ) {
                this.$element.addClass( "scrolly-invisible" )
                
            } else {
                if ( opacity < 0 ) {
                    opacity = 0
                } else {
                    opacity = 1 - dT * 0.002
                }
                if ( this.$element.hasClass( "scrolly-invisible" ) ) {
                    position = this.startPosition + ( dT + ( wH - this.offsetTop ) ) * this.velocity
                } else {
                    position = this.startPosition + dT * this.velocity
                }
                
            }
            // Fix background position
            if ( this.bgStart ) {
                position = position + this.bgStart
            }
            
            if ( this.options.bgParallax === true ) {
                this.$element.css( { backgroundPosition: "50% " + position + "px", opacity: opacity } )
            } else {
                this.$element.css( { top: position, opacity: opacity } )
            }
        }
        
        $.fn[pluginName] = function ( options ) {
            return this.each( function () {
                if ( !$.data( this, "plugin_" + pluginName ) ) {
                    $.data( this, "plugin_" + pluginName, new Plugin( this, options ) )
                }
            } )
        }
        
    },
    IPhoneXHack(){
        if (!/Android/gi.test(navigator.userAgent)) {
            setTimeout(() => {
            const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            // alert(scrollHeight)
            }, 100);
        }
    },
    byCustomerIdCreateQRcode(id) {
        const qrCodeObj = {
            '1': 'https://u.wechat.com/EICTilhhA-rWwbSEhqOe86s',
            '2': 'https://u.wechat.com/MGaQ0n6JUJEIkijzFB8xi9U',
            '6': 'https://u.wechat.com/EGkoOxZ-FuXk7X6pxyV06DM',
            '8': 'https://u.wechat.com/ME6T6rKCL0jUKKihlEMew7Y',
            '10': 'https://u.wechat.com/MJ0v1cmM3k8aZHZ7r6-RH14',
            '13': 'https://u.wechat.com/MBpCDDR7rmvgxRtQQrdyuhQ',
            '16': 'https://u.wechat.com/MJjXWhtHSObQ5GgOxm3Fd1E',
            '17': 'http://weixin.qq.com/r/IbPK0ofEK9pUrcOx9_Yz',
            '18': 'https://u.wechat.com/MF7bXa08E5eS1Vvl_dLTn6g',
            '22': 'https://u.wechat.com/EFbJ_d1ex2VU7sTHGND0Nao',
            '23': 'https://u.wechat.com/EMYu4EAONpZ_rfDNQbRkytM',
            '24': 'https://u.wechat.com/EIWCaDaY5mRK-OIuW94cC2k',
            '26': 'https://u.wechat.com/ED64ajtSWL-YQcfUZfxvACM',
            '28': 'https://u.wechat.com/EGXFov8WO0nCjqg1z8_HPzw',
            '29': 'https://u.wechat.com/EEZXSsE2I8AaTY8XIq8-JRA',
            '30': 'https://u.wechat.com/ENesg45-aepOMaLF9tF9GQM',
            '33': 'https://u.wechat.com/EOrajeg_LaRhXfPlhQ6QIVk',
            '36': 'https://u.wechat.com/MKVojgI_69vr0W41KZjVKHY',
            '37': 'https://u.wechat.com/EMVf5TckmhPWipBVumXEqik',
            '38': 'https://u.wechat.com/EBVId4EJ69kCFZDCpDucgLM',
            '40': 'https://u.wechat.com/MGzAisuyWm9gYqQR5jvrjng',
            '41': 'https://u.wechat.com/MC9tVLrdSx619ZYuqIlhaKs',
            '42': 'https://u.wechat.com/MBaAsj7HisD_xcI9XHjoIEQ',
            '43': 'https://u.wechat.com/MEQKXUw5Jb8AgF74_HAj-qo',
            '44': 'https://u.wechat.com/MJAKsJ5o8SP53OvvQVYZ_PQ',
            '46': 'https://u.wechat.com/MBViLCRbaQQkWRhWzXGB27k',
            '48': 'https://u.wechat.com/MBtjVjhI4lqQ62zI78mkOKU',
            '49': 'https://u.wechat.com/MK0BsBTbOEYzEoE63goMugk',
            '51': 'https://u.wechat.com/EKqqbrs8hap6FwYI7QW5tzk',
            '52': 'https://u.wechat.com/EMvbGaJbcD5TseeDWg6mViY',
            '53': 'https://u.wechat.com/EOK3EyDS6svaqN5SOyHeTpU',
            '54': 'https://u.wechat.com/MGKNRobiW2SMI8iAhOAy9Fg',
            '55': 'https://u.wechat.com/EESiBj7-fY00pvCm5uP5TwU',
            '56': 'https://u.wechat.com/ENyE2Bj6we8ew0_mLEGuQrg',
            '57': 'https://u.wechat.com/MEnJuS16KtPnu5_DgcQLPtw',
            '59': 'https://u.wechat.com/MP-tFVPhNaK7gW8WjoRnj7A',
            '60': 'https://u.wechat.com/MI22HUmIrp7V4ySrFqZ8hvE',
            '61': 'https://u.wechat.com/MLC8AKC12wX58jpPzcdwBdQ',
            '62': 'https://u.wechat.com/MIEzVKzcMaNkFvSx3uGOIW8',
            '63': 'https://u.wechat.com/MJvJjXTi6UwZhxvXWwZ6Xsk',
            '64': 'https://u.wechat.com/EAmpfkW02YiC8sosKn6SaHA',
            '65': 'https://u.wechat.com/MCwV2CYm5pbDUqZa5ZYGjqI',
            '66': 'https://u.wechat.com/EKlnzpCcBCc82VYyxTeAuec',
            '69': 'https://u.wechat.com/MN65mWGHh8NgaOc27Lee8SY',
            '70': 'https://u.wechat.com/MIWyMU1xwDtte83BOdqsonM',
            '71': 'https://u.wechat.com/MKFThDhCQ4R-k5IkKHqa990',
            '72': 'https://u.wechat.com/MIthXgF83m9CZSx3lJn9Hck',
            '75': 'https://u.wechat.com/MKcmlcdNke3WuwDYvP15ZfU',
            '76': 'https://u.wechat.com/MCVRdwAS8gQxAuq4S4tFIu8',
            '77': 'https://u.wechat.com/EPFHbdC27sbrfQDo7dmVtGY',
            '79': 'https://u.wechat.com/MApixs1uakhDQgrsF4etjx0',
            '80': 'https://u.wechat.com/MKv57IXQ-ILHax1KXGf450I',
            '81': 'https://u.wechat.com/MFQKPRw3Dhjkv_6TsQ64Mi0',
            '82': 'https://u.wechat.com/MLD_a0HNsawkcuMeKqqiDE0',
            '83': 'https://u.wechat.com/MKy538D6IKK3mn-ATAn8Ie0',
            '84': 'https://u.wechat.com/EEPogRZfbNSCKYx5CKxb7GY',
            '85': 'https://u.wechat.com/EP_NGyyk5l9IJi_yRQ2dHLA',
            '86': 'https://u.wechat.com/MDtL9uxxyaujdGUewjZMZ5M',
            '87': 'https://u.wechat.com/MGjohySq6r7eF63se4IAiK8',
            '89': 'https://u.wechat.com/MH5XfuVS57m2Wq15flhfrzs',
            '90': 'https://u.wechat.com/MNJf2JW4OLopP0Ocy6UTjgQ',
            '91': 'https://u.wechat.com/MOxrIioTzp-KMUcbBx5-Ce0',
            '92': 'https://u.wechat.com/MPlpeeVpFlQ72fOfJGBAAW0',
            '93': 'https://u.wechat.com/MK9bkmg6Tao-CwQl-ULCjBE',
            '95': 'https://u.wechat.com/MP8mzIVB2Tlehvt5oZu9Hmo',
            '97': 'https://u.wechat.com/MA49f1xkjaphT3B3zAONoNQ',
            '99': 'https://u.wechat.com/EAz-dsRpHHHWITlThaU_dXI',
            '101': 'https://u.wechat.com/MOfpVVPCeBpigGzTvFAcnbI',
            '102': 'https://u.wechat.com/MAKidy_NsR9c8z26XbO0yZw',
            '103': 'https://u.wechat.com/MGtXGftriQPc8C4fTyzgIYg',
            '104': 'https://u.wechat.com/MIAqqWJ2MJ536EPwpXoJ1f4',
            '105': 'https://u.wechat.com/MJq5g3wmOQLOiyD7SVFC_qo',
            '106': 'https://u.wechat.com/ME9E2CgoOr8Fginfa8-r4mU',
            '107': 'https://u.wechat.com/MDf4x1Cgk2VeOYba0uPe3b8',
            '109': 'https://u.wechat.com/MB2CbL3_Di3M4wElnOuQTu0',
            '110': 'https://u.wechat.com/MEuO2wg52L223Tc8942no1U',
            '112': 'https://u.wechat.com/MMUEmZ_C2hYnGIaEaV-Gm9s',
            '113': 'https://u.wechat.com/MEZdB6j4cEqyv4fvznyAbO8',
            '114': 'https://u.wechat.com/MNm7v6lVAJwjgTrCyBDOFfg',
            '115': 'https://u.wechat.com/MBt0YN439lNPLUmbfdffgEE',
            '117': 'https://u.wechat.com/MMkmGg7KyXnlfKCIBArboYA',
            '121': 'https://u.wechat.com/MM5qsu8BY5P_lXyb55u-B1Y',
            '122': 'https://u.wechat.com/MMLlRxhyC1-kGiXVGS6Pavs',
            '125': 'https://u.wechat.com/MDcqabi8mW7fuU7UHoNCiBs',
            '126': 'https://u.wechat.com/MC1rSH__jls3lmbxW6wCAEQ',
            '127': 'https://u.wechat.com/MHcFZckmyrkHYKtoXpWLe3s',
            '130': 'https://u.wechat.com/MNNov5p7QbNMuBiHPLRM_zc',
            '131': 'https://u.wechat.com/MCvoQzh8tUoUPRxn8HwjIwY',
            '132': 'https://u.wechat.com/MJV3jolx5JWtnRBcgZSON4w',
            '133': 'https://u.wechat.com/MD_v5Oif5FdXEP1UWLdAePg',
            '134': 'https://u.wechat.com/MM-hXMAbXlwmdbIpTw0iBL4',
            '135': 'https://u.wechat.com/EL7b8YW4hu23Ro2BctgFuUo',
            '151': 'https://u.wechat.com/MFYukirmFHQ_rt_Tpm9bosU',
            '160': 'https://u.wechat.com/MEW1nOF43RsrQ5kdvhrX9Ww',
            '166': 'https://u.wechat.com/MG1XnPkz4kGZz0SzV7bxTrE',
            '180': 'https://u.wechat.com/MBI8wZhN5ZxFJBCGDeLMVkk',
            '181': 'https://u.wechat.com/MOAdABSHqa6GAIgg4v5ap5c',
            '182': 'https://u.wechat.com/MCWk8FxwooXOFB0Sb7Fu4_I',
            '183': 'https://u.wechat.com/MLyO4IJwc4JJqoyHQBfxOuA',
            '184': 'https://u.wechat.com/MLKvPh7J4lXy63Kx0Fq_C5o',
            '185': 'https://u.wechat.com/MF0hyaNPmfUhbQRjlgz2cwA',
            // '186': 'https://u.wechat.com/MNDdnoF0vRbHr9hi03QIQI0',
            '1008':'https://u.wechat.com/MDBZ0Yl0qi1-TasQZN5HLhw',
            '187': 'https://u.wechat.com/MGClnwrMZ2QMWCxkjSG2kvc',
            '189': 'https://u.wechat.com/MCOpfivkB1k80pGB472a2l8',
            '190': 'https://u.wechat.com/MKPBoossr351N96M5sZI-_U',
            '1888': 'https://u.wechat.com/MJXqEk3V-QVVlxuY-tBRYW0',
            '161': 'https://u.wechat.com/MB6fed6_5LLcS259IvGRaMk',
            '193': 'https://u.wechat.com/MHa_pYG8eNsLKUzxtcW_rGs',
            '198': 'https://u.wechat.com/MJ_hKTJL_8-k43JHE6irTdU'
        }
        const url =  qrCodeObj[id] ? qrCodeObj[id] : Math.floor(Math.random()*2) > 0 ? qrCodeObj['1008'] : qrCodeObj['190']
        return url
    },
    validationLogin(){
 
        return store.state.token?true:false

    },
    validationTeam(params){
        return new Promise(resolve => {
            homeApi.getShoppingCart(params).then((res)=>{
                resolve(res);
            }).catch((res)=>{
                resolve(res.data);
            })
        });
        
    }
}
